import { useEffect } from "react";
import { format } from "date-fns";
import L from "leaflet";
import { toast } from "react-toastify";
import { toastOptions } from "../../../../config/toast";

const InformacionGeneral = (props) => {
  const { infraccion_seleccionada } = props;

  useEffect(() => {
    const buildMap = async () => {
      if (
        !infraccion_seleccionada &&
        (!infraccion_seleccionada.latitud || !infraccion_seleccionada.longitud)
      ) {
        toast.error("No hay información suficiente para generar el mapa", toastOptions);
        return;
      }

      let container = L.DomUtil.get("mapaInfraccion");
      if (container != null) {
        container._leaflet_id = null;
      }

      let map = L.map("mapaInfraccion", { attributionControl: false }).setView(
        [infraccion_seleccionada.latitud, infraccion_seleccionada.longitud],
        16
      );

      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        minZoom: 11,
        maxZoom: 20,
      }).addTo(map);

      L.marker([infraccion_seleccionada.latitud, infraccion_seleccionada.longitud]).addTo(map);
    };

    // return () => map.remove();

    buildMap();
  }, []);

  return (
    <div className=" row   p-0 m-0">
      <div className="col-12 d-flex flex-column gap-2 justify-content-center">
        <div className="d-flex flex-column">
          <span className="fw-bold text-primary" style={{ fontSize: "14px", lineHeight: "10px" }}>Denunciante: </span>
          {infraccion_seleccionada?.nombre_completo_denunciante}
        </div>
        <div className="d-flex flex-column">
          <span className="fw-bold text-primary" style={{ fontSize: "14px", lineHeight: "10px" }}>Documento: </span>
          {infraccion_seleccionada?.documento_denunciante}
        </div>
        <div className="d-flex flex-column">
          <span className="fw-bold text-primary" style={{ fontSize: "14px", lineHeight: "10px" }}>Fecha y hora: </span>
          {format(infraccion_seleccionada?.fecha_hora, "dd/MM/yyyy HH:mm:ss")}
        </div>
        <div className="d-flex flex-column">
          <span className="fw-bold text-primary " style={{ fontSize: "14px", lineHeight: "10px" }}>Tipo de Infracción: </span>
          <span className="text-capitalize">{infraccion_seleccionada?.tipo_infraccion}</span>
        </div>
      </div>
      <div className="col-12">
        <span className="fw-bold text-primary " style={{ fontSize: "14px", lineHeight: "10px" }}>Dirección de la infracción: </span>
        <div id="mapaInfraccion" className="w-100" style={{ height: "300px" }}></div>
      </div>
    </div>
  );
};

export default InformacionGeneral;
